import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { trackGaEvent } from "@/features/ga/trackGaEvent";
import { logError } from "@/features/logger";

interface SurveyCakeTopUpButtonProps {
  orgName: string | undefined;
  orgUuid: string | undefined;
  language: string;
}

/**
 * Deposit ("top-up") button that opens the SurveyCake external deposit link.
 * Disabled until an org name is available.
 *
 * The org name is URL-encoded so names containing spaces or reserved
 * characters (`&`, `+`, ...) cannot produce a malformed query string.
 */
export const SurveyCakeTopUpButton: React.FC<SurveyCakeTopUpButtonProps> =
  function SurveyCakeTopUpButton({ orgName, orgUuid, language }) {
    const { t } = useTranslation();

    const topUpUrl = orgName
      ? (() => {
          try {
            const url = new URL(
              t("billing.deposit.externalLink", { lng: language }),
            );
            url.searchParams.set("aka_in", orgName);
            if (orgUuid) url.searchParams.set("aka_org_uuid", orgUuid);
            return url.toString();
          } catch (error) {
            logError(error);
            return null;
          }
        })()
      : null;

    return (
      <Button
        variant="primary"
        {...(topUpUrl ? { href: topUpUrl } : {})}
        disabled={!topUpUrl}
        endIcon={null}
        onClick={() => {
          trackGaEvent("billingMaacTopUpClick");
        }}
      >
        {t("billing.deposit")}
      </Button>
    );
  };
